import gsap from "gsap";
import { useLayoutEffect } from "react";

const Algorithm = () => {
    useLayoutEffect(() => {
        let ctx = gsap.context(() => {
			let startMarker = "85%";
			gsap.from("#titleAlgorithm", {
				scrollTrigger: {
					trigger: ".algorithm",
					start: `15% ${startMarker}`,
				},
				y: 50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#line1", {
				scrollTrigger: {
					trigger: ".algorithm",
					start: `15% ${startMarker}`,
				},
				x: -50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#line2", {
				scrollTrigger: {
					trigger: ".algorithm",
					start: `15% ${startMarker}`,
				},
                delay: .1,
				x: -50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#line3", {
				scrollTrigger: {
					trigger: ".algorithm",
					start: `15% ${startMarker}`,
				},
                delay: .2,
				x: -50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#subTitleAlgorithm", {
				scrollTrigger: {
					trigger: ".algorithm",
					start: `25% ${startMarker}`,
				},
                // delay: .2,
				y: -50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#video1", {
				scrollTrigger: {
					trigger: ".algorithm",
					start: `50% ${startMarker}`,
				},
				y: -50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#video2", {
				scrollTrigger: {
					trigger: ".algorithm",
					start: `50% ${startMarker}`,
				},
                delay: .2,
				y: -50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#video3", {
				scrollTrigger: {
					trigger: ".algorithm",
					start: `75% ${startMarker}`,
				},
				y: -50,
				opacity: 0,
				duration: .7,
			})
            gsap.from("#video4", {
				scrollTrigger: {
					trigger: ".algorithm",
					start: `75% ${startMarker}`,
				},
                delay: .2,
				y: -50,
				opacity: 0,
				duration: .7,
			})
		});
		return () => ctx.revert();
    }, []);

    return (
        <div className="algorithm">
            <div className="naming" id="titleAlgorithm">Как это работает?</div>
            <h2>
                <div className="line1" id="line1">Простой и прозрачный</div>
                <div className="line2" id="line2">расчета стоимости</div>
                <div className="line3" id="line3">сопровождения под ваши задачи:</div>
            </h2>
            <div className="description" id="subTitleAlgorithm">Калькулятор адаптируется под ваши требования, а прозрачная логика расчетов помогает обосновать стоимость клиентам.</div>
            <ul className="cards">
                <li>
                    <ul className="cardList">
                        <li id="video1">
                            <div className="video"></div>
                            <div className="title">Ввод данных компании</div>
                            <div className="desc">Укажите штат сотрудников, их ФОТ, ежемесячные расходы и другие параметры бизнеса.</div>
                        </li>
                        <li id="video2">
                            <div className="video"></div>
                            <div className="title">Настройка модулей</div>
                            <div className="desc">Выберите нужные разделы («Главный бухгалтер», «Зарплата», «Первичка», «Банк» и др.), задайте периодичность задач, коэффициенты сложности, скидки или условия для клиентов.</div>
                        </li>
                    </ul>
                </li>
                <li>
                    <ul className="cardList">
                        <li id="video3">
                            <div className="video"></div>
                            <div className="title">Итоговая стоимость</div>
                            <div className="desc">Получите детализацию по каждому модулю и общую сумму обслуживания. Меняйте настройки в реальном времени, чтобы сравнить варианты и подобрать оптимальный тариф.</div>
                        </li>
                        <li id="video4">
                            <div className="video"></div>
                            <div className="title">Автоматический расчет</div>
                            <div className="desc">Система анализирует введенные данные, учитывает время выполнения операций, количество документов, специфику деятельности (например, ЕАЭС или локальные операции) и применяет заданные правила.</div>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    );
}

export default Algorithm;